<a {href} class="oddk-menubar-item" {alt} {use}><slot></slot></a>
<script>
export let href;
export let alt;
export let use;
</script>
